import firebase, { db } from '../settings/firebase';

export const sendnotification = (receiveuid, user, type, text, save=false, sec={}) => {
  let obj = {
    body: text,
    fromname: user.data().name,
    fromdisplayid: user.data().displayid,
    fromphotourl: user.data().avatarUrl,
    fromuid: user.id,
    read: false,
    save: save,
    type: type,
    receivedAt: firebase.firestore.FieldValue.serverTimestamp(),
  }
  if (type === "like") {
    obj.pid = sec.id;
    obj.title = sec.title;
  }
  // 相手に通知
  db.collection("messages").doc(receiveuid).collection("notifications").add(obj);
}

// receiveuid: 受信者UID, senduid: 送信者UID/通知ID, type: 通知種類, secid: オプション引数
export const deletenotification = (receiveuid, senduid, type, secid=null) => {
  // 相手の通知から削除
  let notifDocRef = db.collection("messages").doc(receiveuid).collection("notifications")
  if (type === "") {
    console.log(senduid)
    notifDocRef.doc(senduid).delete();
  } else if (type === "follow") {
    notifDocRef.where("fromuid", "==", senduid).where("type", "==", "follow").delete()
  } else if (type === "like") {
    notifDocRef.where("fromuid", "==", senduid).where("type", "==", "like").where("pid", "==", secid).delete()
  }
}